// extracted by mini-css-extract-plugin
module.exports = {"main-component":"waitingClock_main-component__dxc0X"};